import React from 'react';
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone';
import { Content } from '../styles';
import { BasicButton } from '../../Buttons/BasicButton';

interface UploadAreaProps {
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T;
  multipleFiles?: boolean;
  hasImg: boolean;
}

const UploadArea: React.FC<UploadAreaProps> = ({
  getRootProps,
  getInputProps,
  multipleFiles,
  hasImg,
}) => (
  <Content {...getRootProps()} className={hasImg ? 'displayNone' : ''}>
    <input {...getInputProps()} />
    <div className="uploadImgDoc">
      <p>{multipleFiles ? 'Arraste os arquivos para cá' : 'Arraste o arquivo para cá'}</p>
      <p>ou</p>
      <div className="buttonDiv">
        <BasicButton variant="outlined" size="large">
          {multipleFiles ? 'Selecione os arquivos' : 'Selecione o arquivo'}
        </BasicButton>
      </div>
    </div>
  </Content>
);

export default UploadArea;
